import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/status-change-warning.svg'
import _imports_1 from '../../../assets/close-alt.svg'


const _withScopeId = n => (_pushScopeId("data-v-8547538c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "div-banner-body",
  id: "country-status-change-banner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "div-banner-body__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "div-banner-body__icon_img",
    src: _imports_0,
    alt: "warning icon"
  })
], -1))
const _hoisted_3 = { class: "div-banner-body__text" }
const _hoisted_4 = { class: "div-banner-body__top-up-button" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "div-banner-body__close_img",
  src: _imports_1,
  alt: "close image"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('countryStatusChangeBanner.alert')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        text: "Review request",
        variant: "outline",
        size: "small",
        onClick: _ctx.reviewRequest
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("div", {
      class: "div-banner-body__close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.collapseBanner && _ctx.collapseBanner(...args))),
      onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args)))
    }, _hoisted_6, 32)
  ]))
}